import { sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"
import ProsumerHome from "app/components/prosumer_home"
import FeaturedAppletsModule from "app/components/featured_applets_module"
import setupLazyLoad from "app/scripts/setup_lazy_load"
import SetupUnifiedHeaderDropdown from "shared/scripts/setup_unified_header_dropdown"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import "app/components/prosumer/homepage_module_animation"
import "app/components/prosumer/how_it_works_animation"
import "app/components/prosumer/brand_testimonials_scroll"
import "app/scripts/track_component_impression"

import "stylesheets/customer.scss"

sharedVanillaSetup()

Object.assign(window.App.Scripts, {
  SetupUnifiedMobileMenu,
  ProsumerHome,
  FeaturedAppletsModule,
  SetupUnifiedHeaderDropdown,
  setupLazyLoad,
})
